import { Avatar } from "@mui/material";
import React, { useState, useEffect } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CalendarToday } from "@mui/icons-material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import HotelIcon from "@mui/icons-material/Hotel";
import { useLocation, useNavigate } from "react-router-dom";
import "../searchList/slider.css";
import ViewStreamIcon from "@mui/icons-material/ViewStream";
import FlightIcon from "@mui/icons-material/Flight";
import PersonIcon from "@mui/icons-material/Person";
import { axios } from "../../utils/axios";
import { toast } from "react-toastify";
import ViewTrips from "./ViewTrips";
import AddFlight from "./addFlight";
import AddHotel from "./addHotel";
import TravellersModal from "../../components/TravellerModel/index.jsx";
import { formatDateToEEE_MM_d } from "../../utils/utils";
const TripPlanner = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [tabValue, setTabValue] = useState(1);
  const url = useLocation();
  const queryParams = new URLSearchParams(url.search);
  const tripId = queryParams.get("id");
  const [tripDetails, setTripDetail] = useState();
  const [travellerList, setTravellerList] = useState([
    {
      title: "Mr",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      age: "",
    },
  ]);
  const [travellers, setTravellers] = useState([]);
  useEffect(() => {
    getTrip();
    getAllTravellers();
  }, []);
  const getTrip = () => {
    axios
      .get(
        process.env.REACT_APP_BACKEND + `trip/getsingletrip?tripid=${tripId}`
      )
      .then((resp) => {
        if (resp.data.data) {
          setTripDetail(resp.data.data);
        }
      })
      .catch((err) => console.log(err));
  };
  const getAllTravellers = () => {
    axios
      .get(
        process.env.REACT_APP_BACKEND + `trip/getalltravellers?tripid=${tripId}`
      )
      .then((resp) => {
        if (resp.data.data.length !== 0) {
          setTravellers(resp.data.data);
          setTravellerList(resp.data.data);
        }
      })
      .catch((err) => console.log(err));
  };

  const addTravellers = (travellerList) => {
    axios
      .post(process.env.REACT_APP_BACKEND + "trip/addtravellers", {
        tripid: tripId,
        travellers: travellerList,
      })
      .then((resp) => {
        setTravellers(resp.data.data);
        setOpen(false);
        toast.success(resp.data.message);
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="bgsearch">
      <div className="container py-5">
        <div
          className="row bxShadow"
          style={{ backgroundColor: "var(--white-color)", borderRadius: "6px" }}
        >
          <div
            className="col-lg-3 bgsearch col-sm-4  p-4 m-0 "
            style={{
              backgroundColor: "var(--white-color)",
              borderTopLeftRadius: "6px",
              borderBottomLeftRadius: "6px",
            }}
          >
            {/* <div className="bgtripgradient  p-4"> */}
            <div
              className="d-flex align-items-center"
              style={{ gap: 20, cursor: "pointer" }}
              onClick={() => navigate("/trips")}
            >
              <ArrowBackIcon />
              <p>See all trips</p>
            </div>
            <div
              className="d-flex align-items-center  my-3"
              style={{ gap: 10 }}
            >
              <Avatar
                alt={tripDetails?.userId?.name}
                sx={{ width: 30, height: 30 }}
                src={tripDetails?.userId?.picture}
              />
              <p>
                {tripDetails?.userId?.name}
                {tripDetails?.travelers.length !== 0
                  ? `+ ${tripDetails?.travelers.length}`
                  : ""}{" "}
              </p>
            </div>
            <h2 className="my-3"> {tripDetails?.tripName}</h2>

            <div className="d-flex align-items-center">
              <CalendarToday />
              {tripDetails && (
                <p className="ms-2">
                  {" "}
                  {formatDateToEEE_MM_d(tripDetails?.startDate, "UTC")}-{" "}
                  {formatDateToEEE_MM_d(tripDetails?.endDate, "UTC")}
                </p>
              )}
            </div>
            {tripDetails?.location !== "undefined" &&
              tripDetails?.location !== null && (
                <div className="d-flex align-items-center mt-3">
                  <LocationOnIcon />
                  <p className="ms-1">{tripDetails?.location}</p>
                </div>
              )}

            {/* </div> */}
          </div>
          {tripDetails && (
            <div
              className="col-lg-9 col-sm-8 p-0 m-0 bgImageTrip   "
              style={{ backgroundImage: `url(${tripDetails?.locationImg})` }}
            ></div>
          )}
        </div>

        <div className="row">
          <h3 className=" mt-3 ps-0 ">Trip Itinerary</h3>

          <div className="bxShadow cardcont  pe-3 ps-0 d-flex align-items-center justify-content-between">
            <div className="d-flex ps-0" style={{ gap: "10px" }}>
              {iternary.map((it) => (
                <div
                  key={it.id}
                  className={`d-flex align-items-center p-2 py-3 ${
                    tabValue === it.id ? "active" : "tr-tab-inactive"
                  }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => setTabValue(it.id)}
                >
                  {/* <div
                      className={` ${tabValue === it.id ? "active-icon" : ""}`}
                    > */}
                  {it.icon}
                  {/* </div> */}
                  <p
                    // className={`ms-2 ${
                    //   tabValue === it.id ? "active-text " : " "
                    // }`}
                    className={`ms-2`}
                  >
                    {it.title}
                  </p>
                </div>
              ))}
            </div>
            <div>
              <button
                className="btn-contained w100 atb"
                onClick={() => {
                  setOpen(true);
                }}
              >
                + Add Traveler
              </button>
            </div>
          </div>
          <div className=" d-flex" style={{ gap: "14px" }}>
            {travellers.map((it) => (
              <div
                key={it.id}
                className=" cardcont  bxShadow d-flex align-items-center px-3 py-1"
                style={{ backgroundColor: "#CAF1DE" }}
              >
                <PersonIcon sx={{ width: "16px", height: "auto" }} />

                <p className="ms-2 fs-8">
                  {it.title} {it.firstName} {it.lastName}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div>
          <div className="">
            {tabValue === 1 && <AddFlight tripId={tripId} />}
            {tabValue === 2 && <AddHotel tripId={tripId} />}
            {tabValue === 3 && (
              <>
                <ViewTrips
                  tripId={tripId}
                  geoLoation={tripDetails?.geoLocation}
                />
              </>
            )}
          </div>
        </div>
      </div>
      <TravellersModal
        open={open}
        setOpen={setOpen}
        travellerList={travellerList}
        setTravellerList={setTravellerList}
        addTravellers={addTravellers}
        hide={false}
      />
    </div>
  );
};

export default TripPlanner;

const iternary = [
  {
    id: 1,
    title: "Link Flight",
    icon: <FlightIcon sx={{ width: 20, height: "auto" }} />,
  },
  {
    id: 2,
    title: "Add a hotel",
    icon: <HotelIcon sx={{ width: 20, height: "auto" }} />,
  },
  {
    id: 3,
    title: "View Trip",
    icon: <ViewStreamIcon sx={{ width: 20, height: "auto" }} />,
  },
];
